module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/card-corner-green-2fd7e81db34c76ab63776a9fb07fbd0e.svg";